<template>
  <layout-view navTitle="Фильтры">
    <template v-slot:nav>
      <!-- <portal to="tabs">
        <v-tabs v-model="tabSelected" background-color="transparent">
          <v-tab 
            v-for="tab in tabs" 
            :key="tab.name"
            @click="tabSelected = tab.name; $router.push(tab.route)"
          >
            <v-icon class="pr-2">{{ tab.icon }}</v-icon>
            {{ tab.label }}
          </v-tab>
        </v-tabs>
      </portal> -->
      <page-tabs
          :tabs="tabs"
          :tabSelected.sync="tabSelected"
      >
      </page-tabs>
      <div class="px-4">
        <v-text-field
            v-model="filter.usersSearchInput"
            label="Поиск"
            dense outlined hide-details="auto"
            clearable
            class="mt-1 mb-4"
            hint="Ф.И.О., телефон, email"
        />
        <v-text-field
            v-model="filter.detailSearch"
            label="Детальный поиск"
            dense outlined hide-details="auto"
            clearable
            class="mt-1 mb-4"
            hint="По всем данным клиента"
        />
        <v-text-field
            v-model="filter.userId"
            label="ID пользователя"
            dense outlined hide-details="auto"
            clearable
            class="mb-4"
        />

        <template v-if="$router.currentRoute.params.type!=='referral'">
          <v-text-field
              v-model="filter.userOid"
              label="Oid"
              dense outlined hide-details="auto"
              clearable
              class="mb-4"
          />
          <date-interval name="Дата рождения" :valueFrom.sync="filter.birthFrom" :valueTo.sync="filter.birthTo"/>

          <v-text-field
            v-model="filter.birthDay"
            label="День рождения"
            dense outlined hide-details="auto"
            clearable
            class="mt-1 mb-4"
            hint="день и месяц (01.12)"
            v-mask="'##.##'"
          />

          <v-select
              label="Пол"
              v-model="filter.userGender"
              :items="[
                {name:'Любой',value:null},
                {name:'Мужчина',value:'male'},
                {name:'Женщина',value:'female'},
              ]"
              item-text="name"
              outlined dense hide-details="auto" class="my-4"
          />

          <label-view title="Возраст">
            <template v-slot:content>
              <v-row class="pt-2 px-1 mb-2">
                <v-col>
                  <v-text-field v-model="filter.userYearsFrom" clearable label="С" type="number" hide-details outlined
                                dense/>
                </v-col>
                <v-col>
                  <v-text-field v-model="filter.userYearsTo" clearable label="По" type="number" hide-details outlined
                                dense/>
                </v-col>
              </v-row>
            </template>
          </label-view>

          <tag-autocomplete-multiple class="mb-3" :select.sync="filter.tags" :mode.sync="filter.tagsMode" :start.sync="filter.tagStartDate" :end.sync="filter.tagEndDate"  entityType="user"/>

          <com-branch-autocomplete-multiple :select.sync="filter.comBranchs"/>
          <spec-autocomplete-multiple v-if="$router.currentRoute.params.type!=='client'" :select.sync="filter.specs"/>

          <date-interval v-if="$router.currentRoute.params.type==='client'" name="Визиты"
                         :valueFrom.sync="filter.valueFrom" :valueTo.sync="filter.valueTo"/>

          <v-autocomplete
              v-model="filter.visitStatuses"
              :items="visitStatuses"
              label="Статус визита"
              outlined
              dense
              hide-details="auto"
              multiple
              class="mb-4"
              item-text="name"
              item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Не найдено</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item="{item}">
              <v-list-item-title>
                <div class="py-2">
                  <v-avatar :color="item.color" size="12" class="mr-2"/>
                  {{ item.name }}
                </div>
              </v-list-item-title>
            </template>
            <template v-slot:selection="{item}">
              <v-chip class="full-width mt-2" small style="width:95%">
                <v-row no-gutters>
                  <v-col cols="auto">
                    <v-avatar :color="item.color" class="circleIcon mr-2"/>
                  </v-col>
                  <v-col class="text-overflow">{{ item.name }}</v-col>
                  <v-col cols="auto">
                    <v-icon small @click.stop="filter.visitStatuses=filter.visitStatuses.filter((v)=>v!==item.id)">
                      mdi-close-circle
                    </v-icon>
                  </v-col>
                </v-row>
              </v-chip>
            </template>
          </v-autocomplete>

          <user-autocomplete-multiple name="Специалист в визите" _type="spec" :select.sync="filter.visitUserSpecs">
            <template v-slot:appendOuter>
              <tooltip bottom>
                <v-btn
                    @click="filter.visitUserExclude=!filter.visitUserExclude"
                    :class="filter.visitUserExclude ? 'v-btn--active' : ''"
                    icon class="mt-n2"
                >
                  <v-icon>mdi-playlist-remove</v-icon>
                </v-btn>
                <template v-slot:content>
                  Исключить выбор
                </template>
              </tooltip>
            </template>
          </user-autocomplete-multiple>

          <v-select
              label="Последний визит"
              v-model="filter.lastVisit"
              :items="[
                {name:'Любой',value:null},
                {name:'В течении 10 дней',value:'within10days'},
                {name:'Ранее 10 дней',value:'earlier10days'},
              ]"
              item-text="name"
              outlined dense hide-details="auto" class="my-4"
          />

          <checkbox-field name="Был только вчера" help="Последний визит был вчера, но до этого 9 дней не было визитов" class="mb-3" :value.sync="filter.lastVisitYesterday"/>

          <checkbox-field name="Активный медплан" class="mb-3" :value.sync="filter.hasMedPlan"/>

          <checkbox-field name="Долг" class="mb-3" :value.sync="filter.hasDebt"/>

          <checkbox-field name="Предоплата" class="mb-4" :value.sync="filter.hasPrepayment"/>

          <v-row class="px-1">
            <v-col sm="12">
              <v-btn small block depressed color="silver" @click="filterReset">
                Очистить фильтр
              </v-btn>
            </v-col>
            <v-col>
              <v-btn small block depressed color="silver" @click="isCreateOpen=true">
                Создать
              </v-btn>
            </v-col>
            <v-col>
              <v-btn small block depressed color="silver" @click="mergeUsersModal=true">
                Объединить
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-btn small block depressed color="silver" @click="referrerCreate=true">
            Создать направляющего
          </v-btn>
        </template>
      </div>
    </template>
    <template v-slot:content="{height}">
      <n-table-view
          ref="table"
          name="Список"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :headers="headers"
          :tableOptions.sync="filter.tableOptions"
          :selectAll.sync="selectAll"
          :selectIndeterminate.sync="selectIndeterminate"
      >
        <template v-slot:barActions>
          <div v-if="selects.length>0">
            <v-btn depressed small class="mr-2" @click="selectsState.modalOpen();">Выделено: {{ selects.length }}
              <v-icon small class="ml-2">mdi-menu-down</v-icon>
            </v-btn>
            <v-btn depressed small @click="selects=[]">
              <v-icon small class="mr-2">mdi-close</v-icon>
              Отменить
            </v-btn>
          </div>
        </template>
        <template v-slot:item="{item}">
          <tr
              v-if="$router.currentRoute.params.type!=='referral'"
              :style="filter.hasDebt&&loadState.isSuccess ? {background:'#FFEBEE'} : filter.hasPrepayment&&loadState.isSuccess ? {background:'#E8F5E9'} : ''"
              :title="filter.hasDebt&&loadState.isSuccess ?'Есть неоплаченные услуги': null"
          >
            <td>
              <v-checkbox @click.stop="$tools.selectToggle(selects, item)" :input-value="$tools.isSelect(selects, item)"
                          class="ma-0 pa-0" dense hide-details/>
            </td>
            <users-row v-for="header in headers" :key="'td_'+header.value" :header="header" :item="item"
                       :filter="filter"/>
          </tr>
          <!-- referral -->
          <tr v-else @click="referrerId=parseInt(item.id)">
            <template v-for="header in headers">
              <td v-if="header.value === 'id'&&header.visible" :key="'td_'+header.value">{{ item.id }}</td>
              <td v-if="header.value === 'contractNumber'&&header.visible" :key="'td_'+header.value">
                {{ item.contractNumber }}
              </td>
              <td v-if="header.value === 'name'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                {{ item.name }}
              </td>
              <td v-if="header.value === 'lastName'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <UserFullName v-if="item.user" :user="item.user"/>
                <span v-else>-</span>
              </td>
              <td v-if="header.value === 'phone'&&header.visible" :key="'td_'+header.value" class="text-no-wrap">
                <span v-if="$tools.isEmpty(item.user)&&$tools.isEmpty(item.phone)">-</span>
                <call-phone v-else :phone="item.user ? item.user.phone : item.phone"/>
              </td>
              <td v-if="header.value === 'comment'&&header.visible" :key="'td_'+header.value">{{ item.comment }}</td>
              <td v-if="header.value === 'status'&&header.visible" :key="'td_'+header.value">
                {{ item.status === 'active' ? 'активен' : 'неактивен' }}
              </td>
            </template>
          </tr>
        </template>
      </n-table-view>
      <UserCreate :is-open.sync="isCreateOpen" @update:isOpen="$refs.table.load()"
                  :userType="$router.currentRoute.params.type"/>

      <!-- merge users -->
      <merge-users :mergeUsersModal.sync="mergeUsersModal" @update="$refs.table.load()"/>

      <!-- referall -->
      <referrer-card v-if="$router.currentRoute.params.type==='referral'" :referrerId.sync="referrerId"
                     :referrerCreate.sync="referrerCreate" @cancel="$refs.table.load();" @update="$refs.table.load()"/>

      <dialog-view
          :open="selectsState.modal"
          title="Просмотр выделенных элементов"
          @cancel="selectsState.modalClose()"
          content-full-size big
      >
        <template v-slot:content>
          <alert v-if="selects.length===0" icon="mdi-information-outline">Не найдено</alert>
          <v-simple-table v-else class="pa-0" dense fixed-header :height="height*0.8">
            <thead>
            <tr>
              <th></th>
              <th v-for="(v,k) in headers" :key="'header'+k" class="text-no-wrap">{{ v.text }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(v, k) in selects" :key="'select'+k">
              <td>
                <v-checkbox :key="v.id" @click.stop="$tools.selectToggle(selects, v)"
                            :input-value="$tools.isSelect(selects, v)" class="ma-0 pa-0" dense hide-details/>
              </td>
              <users-row v-for="header in headers" :key="'td_'+header.value" :header="header" :item="v" :filter="filter"
                         openLinksNewWindow/>
            </tr>
            </tbody>
          </v-simple-table>
        </template>
        <template v-slot:actions>
          <v-spacer/>
          <v-btn @click="$router.push({ path: '/contactCenter/distribute/' })" text>
            Создать рассылку
          </v-btn>
        </template>
      </dialog-view>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import UserCreate from "@/views/User/UserCreate";
import LayoutView from "@/components/LayoutView";
import LabelView from "@/components/LabelView";
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import NTableView from "@/componentsV2/base/NTableView.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import CallPhone from "@/components/CallPhone.vue";
import MergeUsers from "@/views/User/components/MergeUsers.vue";
import ReferrerCard from "@/views/User/components/ReferrerCard.vue";


import {
  Entity_ComBranch, Entity_ComBuilding,
  Entity_ComDiv, Entity_ComFloor, Entity_ComPlace, Entity_ComRoom, Entity_Spec,
  Entity_User,
  Entity_UserProfile,
  Entity_UserSpec,
  Entity_Visit,
  Entity_Referral,
  Entity_Tag,
  Entity_TagLink
} from "../../../EntityStoreCacheService";
import moment from "moment/moment";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import TagAutocompleteMultiple from "../../componentsV2/custom/TagAutocompleteMultiple.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Stater from "@/plugins/stater";
import DialogView from "@/components/DialogView.vue";
import UsersRow from "@/views/User/UsersRow.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import Api from "@/Api";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";

export default {
  components: {
    Tooltip,
    PageTabs, 
    UserAutocompleteMultiple,
    Alert,
    UsersRow,
    DialogView,
    TagAutocompleteMultiple,
    CallPhone,
    SpecAutocompleteMultiple,
    DateInterval,
    NTableView,
    ComBranchAutocompleteMultiple,
    LabelView,
    LayoutView,
    UserCreate,
    CheckboxField,
    MergeUsers,
    ReferrerCard,
    UserFullName
  },
  data: () => ({
    tabSelected: null,
    tabs: [
      { 
        name: 'clients', 
        perm: 'usersClient', 
        icon: 'mdi-account', 
        label: 'Клиенты', 
        path: '/user/client/' 
      },
      { 
        name: 'spec', 
        perm: 'usersSpec', 
        icon: 'mdi-doctor', 
        label: 'Специалисты', 
        path: '/user/spec/' 
      },
      { 
        name: 'admin', 
        perm: 'usersAdmin', 
        icon: 'mdi-account-tie', 
        label: 'Администраторы', 
        path: '/user/admin/' 
      },
      { 
        name: 'referral', 
        perm: 'usersReferral', 
        icon: 'mdi-account-arrow-right', 
        label: 'Направляющие', 
        path: '/user/referral/' 
      }
    ],
    headers: [],
    filter: {},
    baseFilter: {
      usersSearchInput: null,
      detailSearch: null,
      userId: null,
      userOid: null,
      specs: [],
      comBranchs: [],
      userGender: null,
      tags: [],
      tagsMode: 'simple',
      tagStartDate: null,
      tagEndDate: null,
      userYearsFrom: null,
      userYearsTo: null,
      valueFrom: null,
      valueTo: null,
      hasMedPlan: false,
      hasDebt: false,
      hasPrepayment: false,
      tableOptions: null,
      visitStatuses: [],
      visitUserSpecs: [],
      visitUserExclude: false,
      birthFrom:null,
      birthTo:null,
      lastVisit:null,
      lastVisitYesterday:null,
      birthDay: null
    },
    filterStorageKey:'users_filters?v6',
    visitStatuses: Api.model.Visit.statuses,
    isCreateOpen: false,
    loadState: new State(),
    mergeUsersModal: false,
    referrerId: null,
    referrerCreate: false,

    selects: [],
    selectsState: new Stater()
  }),
  mounted() {
    this.filter = this.$tools.storageGet(this.filterStorageKey, this.$tools.copy(this.baseFilter))

    // if (this.tabs.length>0) {
    //   if (this.tabs[0].route!==this.$router.currentRoute.path)
    //    this.$router.push(this.tabs[0].route)
    // }else {
    //   this.$router.push('/accessDenied/')
    // }

    // if (this.$router.currentRoute.params.type === 'client')
    //   this.tabSelected = 'clients'
    // else if (this.$router.currentRoute.params.type === 'spec')
    //   this.tabSelected = 'spec'
    // else if (this.$router.currentRoute.params.type === 'referral')
    //   this.tabSelected = 'admin'
    // else
    //   this.tabSelected = 'referral'

      
    this.selects = this.$tools.storageGet('users_selects', [])
  },
  watch: {
    '$route': {
      handler: function () {
        const type = this.$router.currentRoute?.params?.type

        switch (type) {
          case 'client':
            this.headers = [
              {text: 'ID', value: 'id', class: 'text-no-wrap', visible: true},
              {text: 'Ф.И.О.', value: 'lastName', class: 'text-no-wrap', visible: true},
              {text: 'Тип', value: 'type', class: 'text-no-wrap', visible: true},
              {text: 'Пол', value: 'userProfile.gender', class: 'text-no-wrap', visible: true},
              {text: 'Дата рождения', value: 'userProfile.birth', class: 'text-no-wrap', visible: true},
              {
                text: 'Мед. карта: филиал / склад / номер',
                value: 'userProfile.medCardNumber',
                class: 'text-no-wrap',
                visible: true
              },
              {text: 'Тэги', value: 'tagLinks', class: 'text-no-wrap', visible: true},
              {text: 'Телефон', value: 'phone', class: 'text-no-wrap', visible: true},
              {text: 'Доп. телефон', value: 'userProfile.phone1', class: 'text-no-wrap', visible: true},
              {text: 'Telegram', value: 'userProfile.telegram', class: 'text-no-wrap', visible: true},
              {text: 'Email', value: 'userProfile.email', class: 'text-no-wrap', width: '100%', visible: true},
            ];
            break;

          case 'spec':
          case 'admin':
            this.headers = [
              {text: 'ID', value: 'id', class: 'text-no-wrap', visible: true},
              {text: 'Ф.И.О.', value: 'lastName', class: 'text-no-wrap', visible: true},
              {text: 'Специальности', value: 'userSpecs', class: 'text-no-wrap', sortable: false, visible: true},
              {text: 'Пол', value: 'userProfile.gender', class: 'text-no-wrap', visible: true},
              {text: 'Дата рождения', value: 'userProfile.birth', class: 'text-no-wrap', visible: true},
              {text: 'Тэги', value: 'tagLinks', class: 'text-no-wrap', visible: true},
              {text: 'Телефон', value: 'phone', class: 'text-no-wrap', visible: true},
              {text: 'Доп. телефон', value: 'userProfile.phone1', class: 'text-no-wrap', visible: true},
              {text: 'Telegram', value: 'userProfile.telegram', class: 'text-no-wrap', visible: true},
              {text: 'Email', value: 'userProfile.email', class: 'text-no-wrap', width: '100%', visible: true},
            ];
            break;

          case 'referral':
            this.headers = [
              {text: 'ID', value: 'id', class: 'text-no-wrap', visible: true},
              {text: '№ контракта', value: 'contractNumber', class: 'text-no-wrap', visible: true},
              {text: 'Имя', value: 'name', class: 'text-no-wrap', visible: true},
              {text: 'Ф.И.О.', value: 'lastName', class: 'text-no-wrap', visible: true},
              {text: 'Телефон', value: 'phone', class: 'text-no-wrap', visible: true},
              {text: 'Комментарий', value: 'comment', class: 'text-no-wrap', visible: true},
              {text: 'Статус', value: 'status', class: 'text-no-wrap', sortable: false, visible: true},
            ];
            break;
        }

      },
      immediate: true
    },
    tabSelected() {
      this.$refs.table.load(true);
    },
    filter: {
      handler() {
        this.$tools.storageSet(this.filterStorageKey, this.filter);

        this.$refs.table.clear();
        this.$refs.table.load();
      },
      deep: true,
    },
    'filter.hasDebt'(v) {
      this.loadState.stateLoading();
      if (v)
        this.filter.hasPrepayment = false;
    },
    'filter.hasPrepayment'(v) {
      this.loadState.stateLoading();
      if (v)
        this.filter.hasDebt = false;
    },
    selects() {
      this.$tools.storageSet('users_selects', this.selects)
    }
  },
  computed: {
    selectAll: {
      get() {
        return this.$tools.isSelectAll(this.$refs.table?.items, this.selects)
      },
      set() {
        this.$tools.selectAllToggle(this.$refs.table?.items, this.selects)
      }
    },
    selectIndeterminate: {
      get() {
        return this.$tools.isSelectIntermidiate(this.$refs.table?.items, this.selects)
      },
    },
  },
  methods: {
    genRequestBuilder(page, onPage, sortFields) {
      let rb;
      if (this.$router.currentRoute.params.type !== 'referral') {
        rb = new Entity_User()
            .selects(Entity_User.id)
            .selects(Entity_User.lastName)
            .selects(Entity_User.firstName)
            .selects(Entity_User.secondName)
            .selects(Entity_User.phone)
            .selects(Entity_User.type)
            .selects([Entity_UserProfile.entity, Entity_UserProfile.birth].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.gender].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.email].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.phone1].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.medCardStore].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.medCardStorePosition].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.medCardNumber].join('.'))
            .selects([Entity_UserProfile.entity, Entity_UserProfile.telegram].join('.'))

            .selects([Entity_User.tagLinks, Entity_TagLink.id].join('.'))
            .selects([Entity_User.tagLinks, Entity_TagLink.status].join('.'))
            .selects([Entity_User.tagLinks, Entity_TagLink.tag, Entity_Tag.name].join('.'))
            .selects([Entity_User.tagLinks, Entity_TagLink.tag, Entity_Tag.color].join('.'))

            .selects([Entity_User.userSpecs, Entity_UserSpec.commentAdmin].join('.'))
            .selects([Entity_User.userSpecs, Entity_UserSpec.isExternalSelfVisitCreate].join('.'))
            .selects([Entity_User.userSpecs, Entity_UserSpec.isSelfVisitCreate].join('.'))
            .selects([Entity_User.userSpecs, Entity_UserSpec.comDiv, Entity_ComDiv.comBranch, Entity_ComBranch.name].join('.'))
            .selects([Entity_User.userSpecs, Entity_UserSpec.spec, Entity_Spec.name].join('.'));
        //.selects([Entity_UserProfile.entity, Entity_UserProfile.birth].join('.'))
        //.filterAnd([Entity_User.entity, Entity_User.user,Entity_User.id].join('.')+'=?', this.$router.currentRoute.params.id


        if (this.$router.currentRoute.params.type === 'spec')
          rb.filterAnd([Entity_User.entity, Entity_User.type].join('.') + '=?', 'spec')
        else if (this.$router.currentRoute.params.type === 'admin')
          rb.filterAnd([Entity_User.entity, Entity_User.type].join('.') + '=?', 'admin')

        if (!this.$tools.isEmpty(this.filter.usersSearchInput)) {
          let v = this.filter.usersSearchInput.trim();

          if (v.includes('@')) {
            rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.email].join('.') + ' LIKE ?', '%' + v + '%')
          } else if (this.$tools.phonesSearch(v).length>0) {
            let phone = this.$tools.phoneFormat(v, true, true);
            rb.filterAnd(
                [Entity_User.entity, Entity_User.phone].join('.') + ' LIKE ? OR ' +
                [Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.phone1].join('.') + ' LIKE ?'
                ,
                phone,
                phone
            )
          } else {
            let arr = v.split(' ');
            if (arr.length === 1 && arr[0][0] === '(') {//Для старой фамилии в скобках
              rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', '%' + arr[0] + '%')
            } else if (arr.length === 1) {
              rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            } else if (arr.length === 2) {
              rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
              rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
            } else if (arr.length === 3) {
              rb.filterAnd([Entity_User.entity, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
              rb.filterAnd([Entity_User.entity, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
              rb.filterAnd([Entity_User.entity, Entity_User.secondName].join('.') + ' LIKE ?', arr[2] + '%')
            }
          }
        }

        if (!this.$tools.isEmpty(this.filter.detailSearch))
          rb.filterAdd(Entity_User.filterAdd_search, this.filter.detailSearch)

        if (!this.$tools.isEmpty(this.filter.userId))
          rb.filterAnd([Entity_User.entity, Entity_User.id].join('.') + ' = ?', this.filter.userId)

        if (!this.$tools.isEmpty(this.filter.userOid))
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.oid].join('.') + ' = ?', this.filter.userOid)

        if (!this.$tools.isEmpty(this.filter.userGender))
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.gender].join('.') + ' = ?', this.filter.userGender)


        if(this.filter.birthFrom)  
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.birth].join('.')+'>=?',moment(this.filter.birthFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')); 

        if(this.filter.birthTo) 
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.birth].join('.')+'<=?',moment(this.filter.birthTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));


        if(this.filter.birthDay)  {
          const birthDay = moment(this.filter.birthDay, 'DD-MM-YYYY').format('DD-MM');
          rb.filterAdd(['birthDay'].join('.'),birthDay)
        }


        if (!this.$tools.isEmpty(this.filter.tags)) {
            rb.filterAnd([Entity_User.entity, Entity_User.tagLinks, Entity_TagLink.status].join('.')+'=?','active');
            let start = this.filter.tagStartDate ?  moment(this.filter.tagStartDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : null;
            let end = this.filter.tagEndDate ?  moment(this.filter.tagEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD') : null;
            rb.filterAdd(Entity_User.filterAdd_userTags, [this.filter.tags.map(v => v.id), this.filter.tagsMode, start, end].join('|'))
        }


        if (this.$router.currentRoute.params.type === 'client') {
          if (!this.$tools.isEmpty(this.filter.valueFrom))
            rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.begin].join('.') + ' >= ?', moment(this.filter.valueFrom, 'DD.MM.YYYY').set({
              hour: 0,
              minute: 0,
              second: 0
            }))
          if (!this.$tools.isEmpty(this.filter.valueTo))
            rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.begin].join('.') + ' <= ?', moment(this.filter.valueTo, 'DD.MM.YYYY').set({
              hour: 23,
              minute: 59,
              second: 59
            }))

          if (!this.$tools.isEmpty(this.filter.visitStatuses))
            rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.status].join('.') + ' IN (?)', this.filter.visitStatuses)

          if (!this.$tools.isEmpty(this.filter.lastVisit)){
            if(this.filter.lastVisit==='within10days'){
              rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.begin].join('.') + '>=?', moment().subtract('10', 'days').format('YYYY-MM-DD HH:mm:ss'))
              rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.status].join('.') + ' IN (?)', ['complete'])
            } else if(this.filter.lastVisit==='earlier10days'){
              rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.begin].join('.') + '<?', moment().subtract('10', 'days').format('YYYY-MM-DD HH:mm:ss'))
              rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.status].join('.') + ' IN (?)', ['complete'])
            }
          }

          if (!this.$tools.isEmpty(this.filter.lastVisitYesterday) && this.filter.lastVisitYesterday){
            rb.filterAdd(Entity_User.filterAdd_lastVisitYesterday)
          }


          if(!this.$tools.isEmpty(this.filter.visitUserSpecs)){
            rb.filterAdd(
                Entity_User.filterAdd_visitUserspec,
                [
                  this.filter.visitUserSpecs.map(v=>v.id).join(','),
                  this.filter.visitUserExclude ? 0 : 1,
                  this.$tools.isEmpty(this.filter.valueFrom) ?
                      '' :
                      moment(this.filter.valueFrom, 'DD.MM.YYYY').set({hour: 0, minute: 0, second: 0}).format('YYYY-MM-DD HH:mm:ss'),
                  this.$tools.isEmpty(this.filter.valueTo) ?
                      '' :
                      moment(this.filter.valueTo, 'DD.MM.YYYY').set({hour: 23, minute: 59, second: 59}).format('YYYY-MM-DD HH:mm:ss'),
                  this.$tools.isEmpty(this.filter.visitStatuses) ?
                      '' :
                      this.filter.visitStatuses.join(','),
                ].join('|')
            );
          }
        }

        if (typeof this.filter.comBranchs !== 'undefined' && this.filter.comBranchs.length > 0) {
          if (this.$router.currentRoute.params.type === 'client') {
            let arr = [];
            this.filter.comBranchs.forEach(v1 => {
              arr.push(v1.id);
            })
            rb.filterAnd([
              Entity_User.entity, Entity_User.visits, Entity_Visit.comPlace, Entity_ComPlace.comRoom,
              Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id
            ].join('.') + ' IN (?)', arr)
            rb.filterAnd([Entity_User.entity, Entity_User.visits, Entity_Visit.comPlace, Entity_ComPlace.comRoom,
              Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id,
            ].join('.') + ' IS NOT NULL')
          } else {
            let arr = [];
            this.filter.comBranchs.forEach(v1 => {
              arr.push(v1.id);
            })
            rb.filterAnd([
              Entity_User.entity, Entity_User.userSpecs, Entity_UserSpec.comDiv,
              Entity_ComDiv.comBranch, Entity_ComBranch.id
            ].join('.') + ' IN (?)', arr)
            rb.filterAnd([
              Entity_User.entity, Entity_User.userSpecs, Entity_UserSpec.comDiv,
              Entity_ComDiv.comBranch, Entity_ComBranch.id
            ].join('.') + ' IS NOT NULL')
          }
        }

        if (this.filter.specs.length > 0) {
          if (this.$router.currentRoute.params.type !== 'client') {
            let arr = [];
            this.filter.specs.forEach(v1 => {
              arr.push(v1.id);
            })
            rb.filterAnd([
              Entity_User.entity, Entity_User.userSpecs, Entity_UserSpec.spec,
              Entity_Spec.id
            ].join('.') + ' IN (?)', arr)
          }
        }


        if (!this.$tools.isEmpty(this.filter.userYearsFrom))
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.birth].join('.') + ' < ?', moment().set({
            hour: 0,
            minute: 0,
            second: 0
          }).subtract(this.filter.userYearsFrom, 'years'))
        if (!this.$tools.isEmpty(this.filter.userYearsTo))
          rb.filterAnd([Entity_User.entity, Entity_User.userProfile, Entity_UserProfile.birth].join('.') + ' > ?', moment().set({
            hour: 23,
            minute: 59,
            second: 59
          }).subtract(this.filter.userYearsTo, 'years'))


        if (this.filter.hasMedPlan)
          rb.filterAdd(['medPlanCount'].join('.'))

        if (this.filter.hasDebt)
          rb.filterAdd(['debtor'].join('.'))

        if (this.filter.hasPrepayment)
          rb.filterAdd(['prepaid'].join('.'))


        rb.addStateCallback((v) => {
          this.loadState.setRequestBuilderState(v)
        })


      } else {//referral
        rb = new Entity_Referral()
            .selects(Entity_Referral.comment)
            .selects(Entity_Referral.contractNumber)
            .selects(Entity_Referral.phone)
            .selects(Entity_Referral.id)
            .selects(Entity_Referral.name)
            .selects(Entity_Referral.status)
            .selects(Entity_Referral.user)

            //user
            .selects([Entity_Referral.user, Entity_User.id].join('.'))
            .selects([Entity_Referral.user, Entity_User.firstName].join('.'))
            .selects([Entity_Referral.user, Entity_User.lastName].join('.'))
            .selects([Entity_Referral.user, Entity_User.secondName].join('.'))
            .selects([Entity_Referral.user, Entity_User.phone].join('.'))

        if (!this.$tools.isEmpty(this.filter.usersSearchInput)) {
          let v = this.filter.usersSearchInput.trim();

          if (v.includes('@')) {
            rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.userProfile, Entity_UserProfile.email].join('.') + ' LIKE ?', '%' + v + '%')
          } else if (this.$tools.phonesSearch(v).length>0) {
            let phone = this.$tools.phoneFormat(v, true, true);
            rb.filterAnd(
                [Entity_Referral.entity, Entity_Referral.phone].join('.') + ' LIKE ? OR ' +
                [Entity_Referral.entity, Entity_Referral.user, Entity_User.phone].join('.') + ' LIKE ? OR ' +
                [Entity_Referral.entity, Entity_Referral.user, Entity_User.userProfile, Entity_UserProfile.phone1].join('.') + ' LIKE ?'
                ,
                phone,
                phone,
                phone
            )
          } else {
            let arr = v.split(' ');

            if (arr.length === 1) {
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
            } else if (arr.length === 2) {
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
            } else if (arr.length === 3) {
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.lastName].join('.') + ' LIKE ?', arr[0] + '%')
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.firstName].join('.') + ' LIKE ?', arr[1] + '%')
              rb.filterAnd([Entity_Referral.entity, Entity_Referral.user, Entity_User.secondName].join('.') + ' LIKE ?', arr[2] + '%')
            }

            rb.filterOr([Entity_Referral.entity, Entity_Referral.name].join('.') + ' LIKE ?', '%' + arr[0] + '%')
          }
        }

        if (!this.$tools.isEmpty(this.filter.userId))
          rb.filterAnd([Entity_Referral.entity, Entity_Referral.id].join('.') + ' = ?', this.filter.userId)

      }

      rb.page(page)
      rb.onPage(onPage);

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })

      sortFields.forEach(v => {
        rb.order(v.field, v.isAsc)
      })

      return rb;
    },
    filterReset() {
      this.filter = this.$tools.copy(this.baseFilter);
      this.$refs.table.load();
    },
  }
}
</script>


